// src/shared/auth/tokenStorage.js
//
// Фасад для работы с токенами.
//   • access-токен → in-memory (sessionStore), НЕ в localStorage.
//   • refresh-токен → HttpOnly cookie, выставляет бэк. Фронт его НЕ читает
//     и НЕ пишет; браузер сам прикладывает cookie к /auth/login/refresh/.
//   • TTL access-токена (для TokenAutoExtend) — в localStorage, это не секрет.
//
// Все consumers (interceptor, centrifuge, file-download) читают access
// ТОЛЬКО через этот модуль.

import { sessionStore } from "./sessionStore";

const LS_ACCESS_TTL_MINUTES = "access_token_ttl_minutes";
const LS_ACCESS_TTL_RECEIVED_AT = "access_token_ttl_received_at";

// Ключи, которые писались старыми версиями кода. На bootstrap/logout их
// затираем, чтобы у действующих пользователей не оставалось «вечного»
// token-state в storage (особенно опасны refresh_*).
const LEGACY_KEYS = [
  "access_token",
  "access_token_expires_at",
  "refresh_token",
  "refresh_token_expires_at",
];

export const tokenStorage = {
  // ===== ACCESS TOKEN (in-memory) =====
  get accessToken() {
    return sessionStore.accessToken;
  },

  // ===== TTL для автопродления (TokenAutoExtend) =====
  get ttlMinutes() {
    const raw = localStorage.getItem(LS_ACCESS_TTL_MINUTES);
    return raw ? Number(raw) : 0;
  },

  get ttlReceivedAt() {
    const raw = localStorage.getItem(LS_ACCESS_TTL_RECEIVED_AT);
    return raw ? Number(raw) : 0;
  },

  get sessionExpiresAt() {
    if (!this.ttlMinutes || !this.ttlReceivedAt) return 0;
    return this.ttlReceivedAt + this.ttlMinutes * 60 * 1000;
  },

  // ===== WRITES =====
  //
  // После /login/confirm/ и /login/face-id/: ответ содержит access_token
  // в body, refresh приходит как Set-Cookie (HttpOnly) — фронт его не видит.
  setFromConfirm(res) {
    if (res?.access_token) {
      sessionStore.setAccessToken(res.access_token);
    }
    if (res?.session_lifetime_seconds) {
      this.updateTTL(res.session_lifetime_seconds / 60);
    }
  },

  // После /login/refresh/ — то же самое (refresh не ротируется фронтом).
  setAccessToken(accessToken) {
    sessionStore.setAccessToken(accessToken);
  },

  updateTTL(ttlMinutes) {
    localStorage.setItem(LS_ACCESS_TTL_MINUTES, String(ttlMinutes));
    localStorage.setItem(LS_ACCESS_TTL_RECEIVED_AT, String(Date.now()));
  },

  clear() {
    sessionStore.clearAccessToken();
    [LS_ACCESS_TTL_MINUTES, LS_ACCESS_TTL_RECEIVED_AT, ...LEGACY_KEYS].forEach(
      (k) => localStorage.removeItem(k)
    );
  },
};
